import { Field, IconButton, Modal, NumberInput } from "@carbon6/c6-frontend-design";
import { DEFAULT_EPISODE_TARGET } from "../../feature/datasetDetailController";
import styles from "./ConfirmModal.module.css";

// 기본 episode 수는 접수 상태를 드는 컨트롤러가 소유한다 — 모달은 표현만 한다.
export { DEFAULT_EPISODE_TARGET };

type RequestProbeModalProps = {
  datasetName: string;
  episodeTarget: number;
  errorMessage: string | null;
  submitting: boolean;
  /** 종료된 Probe 뒤의 재요청인지 — 새 Probe 가 만들어진다는 것을 캡션이 말한다. */
  isRetry: boolean;
  onCancel: () => void;
  onEpisodeTargetChange: (value: number) => void;
  onConfirm: () => void;
};

/**
 * Probe 접수.
 *
 * 진행 중인 Probe 가 있으면 서버가 그 건을 돌려주고(200), 종료된 뒤의 요청은 새 Probe 를
 * 만든다(201) — 과거 증거는 덮이지 않는다.
 */
export function RequestProbeModal({
  datasetName,
  episodeTarget,
  errorMessage,
  isRetry,
  onCancel,
  onConfirm,
  onEpisodeTargetChange,
  submitting,
}: RequestProbeModalProps) {
  return (
    <Modal
      open
      closeOnBackdropClick={!submitting}
      closeOnEscape={!submitting}
      size="sm"
      onClose={onCancel}
    >
      <Modal.Header>
        <Modal.Header.Start>
          <Modal.Header.Title>Probe 요청</Modal.Header.Title>
        </Modal.Header.Start>
        <Modal.Header.End>
          <Modal.Header.Close disabled={submitting} label="닫기" />
        </Modal.Header.End>
      </Modal.Header>
      <Modal.Body>
        <p className={styles.eyebrow}>{datasetName}</p>
        <div className={styles.fields}>
          <Field label="확보할 episode 수" layout="stack" disabled={submitting}>
            <NumberInput
              allowEmpty={false}
              allowNegative={false}
              fullWidth
              min={1}
              mode="integer"
              value={episodeTarget}
              onChange={(value) => onEpisodeTargetChange(value ?? DEFAULT_EPISODE_TARGET)}
            />
          </Field>
          <p className={styles.hint}>
            안정적인 순서의 앞 episode 를 샘플로 확보합니다. Worker 설정에 따라 실제 확보 수는 더
            적을 수 있습니다.
          </p>
        </div>
        <p className={styles.caption}>
          {isRetry
            ? "새 Probe 를 접수합니다. 지난 Probe 의 기록은 그대로 남습니다."
            : "이미 진행 중인 Probe 가 있으면 그 건을 이어서 보여 드립니다."}
        </p>
        {errorMessage === null ? null : (
          <p className={styles.error} role="alert">
            {errorMessage}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.actions}>
          <IconButton
            disabled={submitting}
            text="취소"
            tone="neutral"
            type="button"
            variant="surface"
            onClick={onCancel}
          />
          <IconButton
            disabled={submitting}
            text={submitting ? "요청 중" : "요청"}
            tone="primary"
            type="button"
            variant="solid"
            onClick={onConfirm}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
}
